import React, { useMemo } from 'react';

import { FormField } from '@xcritical/forms';

import { Spacing } from '@crm-framework/spacing';
import { useRegistry } from '@crm-framework/registry';
import { InputFormField, TextareaFormField } from '@crm-framework/form-fields';
import { Label } from '@crm-framework/label';
import { RequiredPosition } from '@crm-framework/label/src/types';
import { ITabsProps, Tabs } from '@crm-framework/tabs';

import { ITabFieldsProps, IDescriptionTabProps, IText } from '../../types';
import { PROMO_REGISTRIES } from '../../consts';

import { InputWrapper } from './styled';

const MyAccountTabFields = ({
  index,
  isRequired,
  disabled,
}: ITabFieldsProps) => {
  const path = `texts.${index}`;
  const descriptionPath = `${path}.description`;
  const titlePath = `${path}.title`;
  const termsPath = `${path}.terms`;

  return (
    <>
      <Spacing mb={20}>
        <Spacing mb={10}>
          <Label lineHeight="0px" htmlFor={titlePath} isRequired={isRequired}>
            Title
          </Label>
        </Spacing>
        <InputWrapper>
          <FormField
            id={titlePath}
            name={titlePath}
            component={InputFormField}
            disabled={disabled}
          />
        </InputWrapper>
      </Spacing>
      <Spacing mb={20}>
        <Spacing mb={10}>
          <Label
            lineHeight="0px"
            htmlFor={descriptionPath}
            isRequired={isRequired}>
            Description
          </Label>
        </Spacing>
        <FormField
          id={descriptionPath}
          name={descriptionPath}
          component={TextareaFormField}
          disabled={disabled}
        />
      </Spacing>
      <Spacing mb={20}>
        <Spacing mb={10}>
          <Label lineHeight="0px" htmlFor={termsPath}>
            Terms
          </Label>
        </Spacing>
        <FormField
          id={termsPath}
          name={termsPath}
          component={TextareaFormField}
          disabled={disabled}
        />
      </Spacing>
    </>
  );
};

export const MyAccountTabs = ({ texts, disabled }: IDescriptionTabProps) => {
  const activeTab = useRegistry<ITabsProps['activeTab']>(
    PROMO_REGISTRIES.ACTIVE_LANG
  );

  const mappedTexts = useMemo(
    () =>
      texts.map(({ languageName }: IText, index: number) => {
        const isRequired = languageName === 'English';

        return {
          label: () => (
            <Label
              lineHeight="0px"
              requiredPosition={RequiredPosition.left}
              isRequired={isRequired}>
              {languageName}
            </Label>
          ),
          component: () => (
            <MyAccountTabFields
              disabled={disabled}
              isRequired={isRequired}
              index={index}
            />
          ),
        };
      }),
    [texts]
  );

  return (
    <Tabs activeTab={activeTab} items={mappedTexts} appearance="vertical" />
  );
};
